import { registerTrigger, triggerNamedNotify } from "../../@helpers/js/observer.js";

export default function ToggleButton(element, { triggerName = ''} = {}) {

    // Because of accessibility concerns allow toggleButton functionality only on buttons and on checkboxes 
    if (element?.tagName !== 'BUTTON' && !(element?.tagName === 'INPUT' && element?.type === 'checkbox')) {
        return false;
    }
 
    const checkbox = element.tagName === 'INPUT' && element.type === 'checkbox';

    registerTrigger('toggle-button-trigger');

    let checkedAttribute = element.getAttribute('aria-checked');
    if (!checkedAttribute && !checkbox) {
        element.setAttribute('aria-checked', false);
    }
    let checked = checkedAttribute?.toLowerCase() === 'true' || element.checked;

    const hasExpandedAttribute = element.hasAttribute('aria-expanded') && element.hasAttribute('aria-controls');
    const expandableElement = hasExpandedAttribute ? document.getElementById(element.getAttribute('aria-controls')) : null;

    element.addEventListener('click', (e) => {
        checked = !checked;
        if (checkedAttribute) {
            element.setAttribute('aria-checked', checked);
        }
        if (hasExpandedAttribute) {
            element.setAttribute('aria-expanded', checked);
            if (expandableElement && expandableElement.tagName === 'DIALOG') {
                if (checked) {
                    expandableElement.show();
                } else {
                    expandableElement.close();
                }
            }
        }
        if (triggerName) {
            triggerNamedNotify('toggle-button-trigger', {name: triggerName, args: {checked} })
        }
    })
};